import { useEffect, useRef, useState } from "react";
import ForceGraph3D from "react-force-graph-3d";
import Node from "./node/Node";
import { CSS2DRenderer } from "three/examples/jsm/renderers/CSS2DRenderer";
import { ReactComponent as ZoomInIcon } from "../assets/BRN-Map-Zoom_In.svg";
import { ReactComponent as ZoomOutIcon } from "../assets/BRN-Map-Zoom_Out.svg";
import "./Zoom.component.scss";

export default function Graph({ data, setSelectedNode, isOpen, setIsOpen }) {
	const fgRef = useRef();
	const [height, setHeight] = useState(0);
	const [width, setWidth] = useState(0);
	console.log(isOpen + " - graph");

	useEffect(() => {
		const fg = fgRef.current;
		// fg.d3Force("link").distance((link) => link.distance);
		fg.d3Force("charge").strength(-100);
		fg.d3Force("link").distance((link) => link.distance);
		// fg.d3Force("collide").radius((d) => 200);
		// fg.d3Force("x").strength(0.1);
		// fg.d3Force("y").strength(0.1);
		// fg.d3Force("z").strength(0.1);
		// fg.d3Force("link").strength(0.1);
		// fg.d3Force("charge").strength(0.1);
		// fg.d3Force("collide").strength(0.1);
		fg.d3Force("center").strength(0.5);
		// fg.zoom("5");
		fg.refresh();
	}, [data]);

	useEffect(() => {
		function handleResize() {
			setHeight(
				document.querySelector(".graph-container")
					? document.querySelector(".graph-container").clientHeight
					: 0
			);
			setWidth(
				document.querySelector(".graph-container")
					? document.querySelector(".graph-container").clientWidth
					: 0
			);
		}
		// Add event listener
		window.addEventListener("resize", handleResize);
		// Call handler right away so state gets updated with initial window size
		handleResize();
		// Remove event listener on cleanup
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	//Overriding the node on click to position them
	function onClickHandle(node) {
		setSelectedNode(node);
		setIsOpen(true);

		console.log(node.type);

		// if (node.type == 'researcher') {
		// 	console.log('yes');
		// 	if (document.querySelector('.sidebar').classList.contains('left-full')) {
		// 		console.log('left yes');
		// 		document.querySelector('.sidebar').classList.remove('left-full');
		// 		document.querySelector('.sidebar').classList.add('right-0');
		// 		document.querySelector('.sidebar').classList.add('bg-black');
		// 		document.querySelector('.sidebar .hidden').classList.add('block');
		// 		document.querySelector('.sidebar .hidden').classList.remove('hidden');
		// 	} else {
		// 		console.log('left no');
		// 		document.querySelector('.sidebar').classList.remove('right-0');
		// 		document.querySelector('.sidebar').classList.add('left-full');
		// 		document.querySelector('.sidebar').classList.remove('bg-black');
		// 		document.querySelector('.sidebar .block').classList.add('hidden').classList.remove('block');
		// 		document.querySelector('.sidebar .block').classList.remove('block');
		// 	}
		// } else if (node.type == 'focus') {
		// 	if (document.querySelector('.sidebar').classList.contains('left-full')) {
		// 		console.log('left yes');
		// 		document.querySelector('.sidebar').classList.remove('left-full');
		// 		document.querySelector('.sidebar').classList.add('right-0');
		// 		document.querySelector('.sidebar').classList.add('bg-brn-blue');
		// 		document.querySelector('.sidebar .hidden').classList.add('block');
		// 		document.querySelector('.sidebar .hidden').classList.remove('hidden');
		// 	} else {
		// 		console.log('left no');
		// 		document.querySelector('.sidebar').classList.remove('right-0');
		// 		document.querySelector('.sidebar').classList.add('left-full');
		// 		document.querySelector('.sidebar').classList.remove('bg-brn-blue');
		// 		document.querySelector('.sidebar .block').classList.add('hidden').classList.remove('block');
		// 		document.querySelector('.sidebar .block').classList.remove('block');
		// 	}
		// } else if (node.type == 'location') {
		// 	if (document.querySelector('.sidebar').classList.contains('left-full')) {
		// 		console.log('left yes');
		// 		document.querySelector('.sidebar').classList.remove('left-full');
		// 		document.querySelector('.sidebar').classList.add('right-0');
		// 		document.querySelector('.sidebar').classList.add('bg-brn-red');
		// 		document.querySelector('.sidebar .hidden').classList.add('block');
		// 		document.querySelector('.sidebar .hidden').classList.remove('hidden');
		// 	} else {
		// 		console.log('left no');
		// 		document.querySelector('.sidebar').classList.remove('right-0');
		// 		document.querySelector('.sidebar').classList.add('left-full');
		// 		document.querySelector('.sidebar').classList.remove('bg-brn-red');
		// 		document.querySelector('.sidebar .block').classList.add('hidden').classList.remove('block');
		// 		document.querySelector('.sidebar .block').classList.remove('block');
		// 	}
		// }

		const fg = fgRef.current;
		// console.log(fg);
		// fg.zoomToFit();
		fg.zoomToFit(1);
		// fg.cameraPosition(50, 50, 3000);
		fg.d3Force("center").strength(0.05);

		//Adjust the distance for the focus nodes as they are bigger and looked squashed
		if (node.type === 'focus') {
			fg.d3Force("link").distance((link) => (link.distance + 1000));
		} else {
			fg.d3Force("link").distance((link) => (link.distance));
		}
		fg.refresh();

	}

	//On click handler for both zoom buttons

	const zoomInClickHandler = (event) => {
		const fg = fgRef.current;
		fg.scene().scale.z += 0.1;
		fg.scene().scale.x += 0.1;
		fg.scene().scale.y += 0.1;

		fg.refresh();
	};

	const zoomOutClickHandler = (event) => {
		const fg = fgRef.current;
		fg.scene().scale.z -= 0.1;
		fg.scene().scale.x -= 0.1;
		fg.scene().scale.y -= 0.1;

		fg.refresh();
	};

	return (
		<>
			<ForceGraph3D
				backgroundColor={"rgba(0,0,0,0)"}
				ref={fgRef}
				graphData={data}
				nodeAutoColorBy="group"
				linkColor={() => "black"}
				linkWidth={0}
				linkOpacity={1}
				height={height}
				width={width}
				showNavInfo={true}
				enableNavigationControls={true}
				onNodeClick={(node) => onClickHandle(node)}
				extraRenderers={[new CSS2DRenderer()]}
				nodeThreeObject={(node) => Node(node)}
				nodeThreeObjectExtend={true}
				nodeOpacity={0}
			/>

			<div className="absolute right-0.5 bottom-0.5 zoom-btns">
				<button onClick={zoomInClickHandler} className='zoom-in'>
					<div className="in">
						<ZoomInIcon />
					</div>
				</button>
				<button onClick={zoomOutClickHandler} className='zoom-out'>
					<ZoomOutIcon />
				</button>
			</div>
		</>
	);
}
